module.exports = __webpack_public_path__ + "static/media/luigi.8a5941c6.png";